export const smartRound = (num: number) => {
  if (num === 0 || !isFinite(num)) return num // Handle special cases

  const absNum = Math.abs(num)
  if (absNum >= 1) {
    // For numbers greater than or equal to 1, no decimal places
    return Math.round(num)
  } else {
    // For numbers less than 1, find the first significant digit
    const numDigits = Math.ceil(-Math.log10(absNum) + 1)
    return parseFloat(num.toPrecision(numDigits))
  }
}

export const formatNum = (num: number) => {
  if (num < 1) {
    return num.toPrecision(2)
  }
  const units = ['k', 'M', 'B', 'T']
  let unitIndex = -1

  while (num >= 1000 && unitIndex < units.length - 1) {
    unitIndex++
    num /= 1000
  }

  return unitIndex === -1 ? `${smartRound(num)}` : `${smartRound(num)}${units[unitIndex]}`
}

export const formatDuration = (seconds: number) => {
  const hours = Math.floor(seconds / 3600)
  const mins = Math.floor((seconds % 3600) / 60)
  const secs = Math.floor(seconds % 60)
  const mssecs = Math.floor((seconds * 1000) % 1000)

  let result = []

  if (hours > 0) result.push(`${hours}h`)
  if (mins > 0) result.push(`${mins}min`)
  if (secs > 0) result.push(`${secs}s`)
  if (mssecs > 0) result.push(`${mssecs}ms`)
  if (result.length === 0) return '0s'

  return result.join(', ')
}

export const formatPrice = (val: number) => (val >= 0.01 ? val.toFixed(2) : val.toPrecision(2))

export const asMillionTokens = (val?: number) => (val ? val * 4000000 : 0)
export const fromMillionTokens = (val?: number) => (val !== undefined ? val / 4000000 : undefined)
